import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d6qznhf5cn: FaireBrandEntity = {
  token: "b_d6qznhf5cn",
  type: "brand",
  name: "Maker Magic 3D Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/ba2a228fa4d46fb38a1b4dfa5ac3e7a2baf016c46c7debd20f72b68cbfd5c269.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a200df6844e367bc61c5627ef65a9f0c27e1f2c2ac9c65a88665d74bfcc71edb.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ba2a228fa4d46fb38a1b4dfa5ac3e7a2baf016c46c7debd20f72b68cbfd5c269.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a200df6844e367bc61c5627ef65a9f0c27e1f2c2ac9c65a88665d74bfcc71edb.png",
  location: "Clarksville, TX, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Our Story: \n\nMaker Magic 3D Co. was founded in 2024 out of a passion for creativity and 3D printing.\n\nEvery item is carefully 3D printed, inspected, and finished using premium materials to ensure a high-quality product that we're proud to offer.\n\nOur collection includes fun fidget clickers, desk accessories, keychains, paperclip bookmarks, organizers, and unique gift items, with new products added regularly. We believe there's something for everyone and are always expanding our collection with fresh, exciting designs.\n\nAt Maker Magic 3D Co., our goal is simple: to provide retailers with unique, high-quality products that spark smiles and keep customers coming back for more.\n\nWhether you're looking for fun impulse buys, conversation starters, or unique gifts, we're committed to offering products that stand out on your shelves.\n\nThank you for supporting our small business. We're excited to help you bring a little Maker Magic to your customers!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:32.389Z",
    importedBy: "entity-db-cli",
  },
};
